import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SidebarItemStore } from '@core/components/sidebar/components/sidebar-item/sidebar-item.store';
import { getLinkItemClasses } from '@core/components/sidebar/components/sidebar-item/sidebar-item.component';

@Component({
  selector: 'app-sidebar-item-expanded-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, FontAwesomeModule],
  template: `
    <div
      class="not-highlightable group flex w-full cursor-pointer items-center rounded-lg border"
      [ngClass]="itemLinkClasses">
      <div class="flex items-center justify-center p-2">
        <fa-icon
          class="size-6"
          [ngClass]="iconClasses"
          [icon]="icon()"></fa-icon>
      </div>

      <div class="flex w-full min-w-0 justify-between">
        <span class="min-w-0 truncate pr-2 text-nowrap">
          {{ mainLabel() }}
        </span>

        <ng-content />
      </div>
    </div>
  `,
})
export class SidebarItemExpandedLayoutComponent {
  /** INJECTIONS **/
  /****/
  private readonly store = inject(SidebarItemStore);

  /** INPUTS **/
  /****/
  readonly isActive = input.required<boolean>();

  /** PROPERTIES **/
  /****/
  protected readonly icon = this.store.icon;

  /****/
  protected readonly mainLabel = this.store.mainLabel;

  protected get itemLinkClasses() {
    return getLinkItemClasses(this.isActive());
  }

  protected get iconClasses() {
    return this.isActive()
      ? 'text-greenish-500'
      : 'group-hover:text-greenish-500';
  }
}
